import { DocumentService } from 'src/app/core/services/document.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { NotificationService } from 'src/app/core/services/notification.service';
import { Message } from 'src/app/core/class/message';
import {Paginate} from "../search-document-contract-moha.component";
import {
  EnumContractStatus,
  EnumContractUserRole,
  EnumContractUserStatus
} from "../../../../../../../core/constants/contract";
import {AutoUserService} from "../../../../../../../core/services/auto-user.service";
import {
  WarningReselectSignApproverComponent
} from "../../warning-reselect-sign-approver/warning-reselect-sign-approver.component";
import {CommonService} from "../../../../../../../core/services/common.service";
import {MatDialog} from "@angular/material/dialog";
import {ContractService} from "../../../../../../../core/services/contract.service";
import {ToastrService} from "ngx-toastr";
import {WarningComponent} from "../../../../../../../shared/components/warning/warning.component";
import {BlockUI, NgBlockUI} from "ng-block-ui";
import {ProcessingService} from "../../../../../../../core/services/processing.service";
@Component({
  selector: 'app-signature-process-popup-moha',
  templateUrl: './signature-process-popup-moha.component.html',
  styleUrls: ['./signature-process-popup-moha.component.scss']
})
export class ListSignatureProcessPopupComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  listUser = [];
  dataSelected = [];
  checkAll: boolean;
  isProcess = false;
  isShowProgress = false;
  idTimeout = null;
  nzCheckLoadingUser: boolean;
  filteredUserOptions: any;
  isFormChanging: boolean;
  newInitialInfo: any;
  newInitialInfoNew:any;
  initialInfo: any;
  private userSign = [];
  inputUserValue: string;
  sendEmail = true;
  documentCode = '';
  timeOut: any;
  // Number of checked documents
  private contractId: string;
  public countCheck = 0;
  columnDefinitions = [
    { def: 'STT', showMobile: true },
    {def: 'contractDocument', showXS: true, showSM: true, showMD: true},
    {def: 'userName', showXS: true, showSM: true, showMD: true},
    {def: 'result', showXS: true, showSM: true, showMD: true},
    {def: 'detail', showXS: true, showSM: true, showMD: true},
  ];
  listData = [];
  listDataPopup = [];
  page = 0;
  pageSize = 10;
  listDataTotal = [];
  percent: 0;
  subTitle: string;
  isStop = false;
  spanningColumns = ['priority', 'status', 'dateCreated'];

  spans = [];
  constructor(
    public dialogRef: MatDialogRef<ListSignatureProcessPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private documentService: DocumentService,
    public autoUserService: AutoUserService,
    private commonService: CommonService,
    private contractService: ContractService,
    private processingService: ProcessingService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,


  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = false;
    this.getDisplayedColumns();
  }
  paginate: Paginate;
  displayedColumns: string[] = [];
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  ngOnInit() {
    this.listDataPopup = [];
    this.listDataTotal = [];
    this.listDataTotal = Array.from(this.data.dataSelected.values());
    this.listDataPopup = this.data.SignatureProcess;
    if (this.data.isProcess && !this.listDataPopup) {
      // this.listDataPopup = JSON.parse(localStorage.getItem("listDataPopupSignature"));
      this.onProcessing();
    }
    else{
      this.listDataPopup.forEach((ele ,i) => {
        if(i < 10){
          this.listData.push(ele);
        }
        ele.order = i+1;
      });
      this.paginate = {
        currentPage: this.page,
        pageSize: this.pageSize,
        totalRow: this.listDataPopup.length,
        totalPage: Math.ceil(this.listDataPopup.length / this.pageSize),
        totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / this.pageSize), 1),
        no: this.counter(this.pageSize, this.page * this.pageSize + 1)
      };
    }
    // const subTitleStr = this.commonService.format(this.message.getMessage('messages.confirm_signature_process_list_docs_draft'), this.data[1].total - this.data[0].data.length, this.data[1].total);
    // this.subTitle = this.data[0].data.length === this.data[0].total ? '' : subTitleStr;
    this.onProcessing();
    this.newInitialInfo = this.data.newInitialInfoValue ? this.data.newInitialInfoValue : [];
    if (this.newInitialInfo.length === 0 && JSON.parse(localStorage.getItem("newInitialInfo"))) {
      this.newInitialInfo = JSON.parse(localStorage.getItem("newInitialInfo"));
    }
    this.isProcess = this.data.isProcess ? this.data.isProcess : false;
    this.isShowProgress = this.isProcess;
  }

  counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }
  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
      case 'CANCEL':
        return this.message.getMessage('sign_contract_flow.process');
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }
  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red', 'border': '1px solid red', 'border-radius': '5px'};
      case 'PROCESSING':
      case 'CANCEL':
        return {'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px'};
      case 'DONE':
        return {'color': 'green', 'border': '1px solid green', 'border-radius': '5px'};
      default:
        return {};
    }
  }
  onFilterData(page: number = 0, pageSize: number = 10) {
    this.listData = [];
    let a = page * pageSize ;
    this.listDataPopup.forEach((ele ,i) => {
      if(a <= i  && i < a + pageSize){
        this.listData.push(ele);
      }
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / pageSize), 1),
      no: this.counter(pageSize, page * pageSize + 1)
    };
  }

  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.sign_multi_stop_process'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        const signContractId = this.data.signContractId;
        this.isStop = true;
        this.documentService.CancelContractFlowSignProcess(signContractId).subscribe(
          (res) => {
            if (res && res.success) {
              this.processingService.processingMultiSignStatus.next(false);
              this.processingService.processingCheckMan.next(3);
              localStorage.setItem('checkMan', '3' );
              this.processingService.processingnewInitialInfoValue.next(this.newInitialInfoNew);
              this.processingService.processingMultiSignCancel.next(this.isStop);
              this.isShowProgress = false;
              this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
                if (!res || !res.data.lotDetails) {
                  return;
                }
                // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
                this.listDataPopup = res.data.lotDetails;
                this.listDataPopup.forEach(ele => {
                  if(!ele.statusName){
                    ele.statusName = ele.status;
                    ele.status = ele.statusContract
                  }
                  // res.data.lotDetails.forEach(ala => {
                  //   if(ele.contractId === ala.contractId ){
                  //     if(ala.errorMessage){
                  //       ele.errorMessage = ala.errorMessage;
                  //     }
                  //     if(ala.status){
                  //       ele.statusName = ala.status;
                  //     }
                  //   }
                  // })
                })
                this.onFilterData(this.page,this.pageSize)
              });
              this.processingService.processingnewInitialInfoValue.next('');
              localStorage.removeItem("newInitialInfo");
              this.toastr.success(this.message.getMessage('messages.process_multi_stop'));
            } else {
              this.processingService.processingnewInitialInfoValue.next('');
              localStorage.removeItem("newInitialInfo");
              this.toastr.error(this.message.getMessage('messages.sign_process_stop_fail'));
            }
          },
          (err) => {
          },
          () => {
          }
        );
      }
    });
  }

  onClickCancelButton() {
    this.dialogRef.close();
  }
  onNoClick() {
    this.dialogRef.close();
  }
  getCommonElements(array1,array2){
    const idMap = {};
    array1.forEach((ele,i) => {
      idMap[ele.contractId] = i;
    })
    const commonElements = [];
    array2.forEach(ala => {
      if (idMap.hasOwnProperty(ala.contractId)){
        commonElements.push(ala);
      }
    });
    return commonElements;
  }
  onProcessing() {
    if (this.data.signContractId) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        }
        // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
        this.listDataPopup = res.data.lotDetails;
        this.listDataPopup.forEach(ele => {
          if(!ele.statusName){
            ele.statusName = ele.status;
            ele.status = ele.statusContract
          }
          // res.data.lotDetails.forEach(ala => {
          //   if(ele.contractId === ala.contractId ){
          //     if(ala.errorMessage){
          //       ele.errorMessage = ala.errorMessage;
          //     }
          //     if(ala.status){
          //       ele.statusName = ala.status;
          //     }
          //   }
          // })
        })
        this.onFilterData(this.page,this.pageSize);
      });
    }
    const proccesingTaskSub = this.processingService.processingMultiSign.subscribe(ref => {
      const process = ref;
      if (process > 0) {
        this.percent = process;
        if (this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
            this.listDataPopup = res.data.lotDetails;
            this.listDataPopup.forEach(ele => {
              if(!ele.statusName){
                ele.statusName = ele.status;
                ele.status = ele.statusContract
              }
              // res.data.lotDetails.forEach(ala => {
              //   if(ele.contractId === ala.contractId ){
              //     if(ala.errorMessage){
              //       ele.errorMessage = ala.errorMessage;
              //     }
              //     if(ala.status){
              //       ele.statusName = ala.status;
              //     }
              //   }
              // })
            })
            this.onFilterData(this.page,this.pageSize);
          });
        }
        if (process === 100 && this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            // this.listDataPopup = this.getCommonElements(res.data.lotDetails,this.listDataPopup);
            this.listDataPopup = res.data.lotDetails;
            this.listDataPopup.forEach(ele => {
              if(!ele.statusName){
                ele.statusName = ele.status;
                ele.status = ele.statusContract
              }
              // res.data.lotDetails.forEach(ala => {
              //   if(ele.contractId === ala.contractId){
              //     if(ala.errorMessage){
              //       ele.errorMessage = ala.errorMessage;
              //     }
              //     if(ala.status){
              //       ele.statusName = ala.status;
              //     }
              //   }
              // })
            })
            this.onFilterData(this.page,this.pageSize);
          });
          this.isStop = true;
          this.timeOut = setTimeout(() => {
            this.isShowProgress = false;
          }, 2000);
        }
      }
    });
  }
  onClickConfirmButton() {
    const dialogRef = this.dialog.open(WarningComponent, {
      width: '350px',
      data: this.commonService.format(this.message.getMessage('messages.signature_process'), this.listDataPopup.length, this.newInitialInfo.name)
    });
    dialogRef.afterClosed().subscribe(rss => {
      localStorage.setItem("listDataPopupSignature", JSON.stringify(this.listDataPopup));
      if (rss) {
        const listContractId = [];
        this.listDataPopup.forEach(ele => {
          listContractId.push(ele.contractId)
        })
        const data = {
          contractIdsStr: listContractId,
          userInitial: {
            ...this.newInitialInfo,
            userId: this.newInitialInfo.id
          }
        };
        this.listDataPopup.forEach(ele =>{
          ele.statusName = 'CANCEL';
        })
        this.onFilterData(this.page,this.pageSize);
        this.processingService.processingMultiSign.next(0);
        this.blockUI.reset();
        this.blockUI.start('');
        const body = this.listDataPopup.map(item => {
          return item.id;
        });
        this.documentService.signatureProcessLotFlow(data)
          .subscribe({
            next: rs => {
              if (rs && rs.success) {
                this.isProcess = true;
                this.isShowProgress = true;
                this.processingService.processingMultiSignStatus.next(this.isProcess);
                this.processingService.processingCheckMan.next(3);
                localStorage.setItem('checkMan', '3' );
                this.newInitialInfoNew = this.newInitialInfo;
                this.processingService.processingnewInitialInfoValue.next(this.newInitialInfo);
                localStorage.setItem("newInitialInfo", JSON.stringify(this.newInitialInfo));
                this.data.signContractId = rs.data;
                this.data.onClickConfirmButtonSignProcess();
                this.onProcessing();
                this.blockUI.stop();
              } else {
                this.blockUI.stop();
                this.toastr.error(rs.message);
              }
            },
            error: err => {
              this.blockUI.stop();
            }
          });
      } else {
        dialogRef.close();
      }
    });
  }
  getDisplayedColumns() {
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.displayedColumns = this.columnDefinitions
        .filter(cd => cd.showXS)
        .map(cd => cd.def);
    } else {
      if (this.mediaBreakpoint === SCREEN_SIZE.MD) {
        this.displayedColumns = this.columnDefinitions
          .filter(cd => cd.showMD)
          .map(cd => cd.def);
      } else {
        this.displayedColumns = this.columnDefinitions.map(cd => cd.def);
      }

    }
  }

  /**
   * check box change event.
   * @param item document item.
   * @param isChecked status of checkbox.
   */
  public onSelectionChange() {
    this.updateSignButtonsStatus();
  }


  public updateSignButtonsStatus() {
    if (this.listUser == null
      || this.listUser.length === 0) {
      return;
    }

    this.countCheck = 0;
    this.listUser.forEach(data => {
      data.updatedTime = null
      if (data.checked) {
        this.countCheck++;
      }

      const index = this.dataSelected.findIndex(item => item.id === data.id);
      if (index !== -1 && !data.checked) {
        this.dataSelected.splice(index, 1);
      } else if (index === -1 && data.checked) {
        this.dataSelected.push(data);
      }
    });

    // check all enable.
    if (this.countCheck === this.listUser.length) {
      this.checkAll = true;
    } else {
      this.checkAll = false;
    }
  }

  public checkAllDocument() {
    this.listUser.forEach(data => {
      data.checked = this.checkAll;
    });
    this.updateSignButtonsStatus();
  }

  // onProcessing() {
  //   if (this.data.signContractId) {
  //     this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
  //       if (!res || !res.data.lotDetails) {
  //         return;
  //       }
  //       this.dataSource = res.data.lotDetails;
  //     });
  //   }
  //   const proccesingTaskSub = this.processingService.processingMultiSign.subscribe(ref => {
  //     const process = ref;
  //     if (process > 0) {
  //       this.percent = process;
  //       if (this.data.signContractId) {
  //         this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
  //           if (!res || !res.data.lotDetails) {
  //             return;
  //           }
  //           this.dataSource = res.data.lotDetails;
  //         });
  //       }
  //       if (process === 100 && this.data.signContractId) {
  //         this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
  //           if (!res || !res.data.lotDetails) {
  //             return;
  //           }
  //           this.dataSource = res.data.lotDetails;
  //         });
  //         // this.isStop = true;
  //         this.timeOut = setTimeout(() => {
  //           this.isShowProgress = false;
  //         }, 2000);
  //       }
  //     }
  //   });
  // }
  onChangeUserSignSearch(event): void {
    if (this.idTimeout) {
      clearTimeout(this.idTimeout);
    }
    setTimeout(
      () => {
        if (event.trim().length > 0) {
          this.nzCheckLoadingUser = true;
          this.autoUserService.fetchAutoSignatureProcess(event.trim(), this.data.signContractId)
            .then(result => {
              let listIdApproval = (this.userSign || []).filter(item => item.role === EnumContractUserRole.APPROVE && item.status !== EnumContractUserStatus.PROCESSING);
              listIdApproval = listIdApproval.map(item => item.userId);
              this.filteredUserOptions = result;
            }).finally(() => {
            this.nzCheckLoadingUser = false;
          });
        } else {
          this.filteredUserOptions = [];
        }
      }, 250
    );
  }
  autocompleteUserSelected($event, user: any) {
    if ($event.isUserInput) {
      this.isFormChanging = true;
      this.newInitialInfo = user;
    }
  }

  onClickBtnConfirm() {
    const dialogRe = this.dialog.open(WarningReselectSignApproverComponent, {
      width: '40%',
      data: this.commonService.format(
        this.message.getMessage('re_submit_sign_confirmation.confirm_re_signature_process'),
        this.documentCode,
        this.initialInfo.name,
        this.initialInfo.email,
        this.initialInfo.phone,
        this.newInitialInfo.fullName,
        this.newInitialInfo.email,
        this.newInitialInfo.phone,
      )
    });
    dialogRe.afterClosed().subscribe(rs => {
      if (rs) {
        const data = {
          contractId: this.data.contractId,
          userInitial: {
            ...this.initialInfo,
            userId: this.initialInfo.id
          }, // người trình ký cũ
          userApprove: {
            ...this.newInitialInfo,
            userId: this.newInitialInfo.id
          }, // người trình ký lại
          reason: rs // Lý do trình ký lại
        };
        this.contractService.addUserSignatureProcess(data).subscribe(result => {
          if (!result.success) {
            this.toastr.error(result.message);
          } else {
            this.toastr.success(this.message.getMessage('messages.re_signature_process_success'));
            this.dialogRef.close(true);
          }
        }, error => {
          this.toastr.error(this.message.getMessage('messages.re_signature_process_fail'));
        });
      }
    });

  }


  protected readonly enumContractStatus = EnumContractStatus;
}

